{
  "title": "位置情報を共有すると、チェックインをスムーズに進められます",
  "body": "申し訳ありませんが、位置情報にアクセスできないとチェックインを完了できません。続行するには位置情報へのアクセスを許可してください。位置情報は倉庫のチェックインにのみ使用され、保存したり第三者と共有したりすることはありません。",
  "shareLocation": "位置情報を共有する"
}
